import { useCallback, useEffect, useState } from "react";
import { FVD_PUSH_STATUSES } from "score-common";
import { useScoreApi, unwrap } from "../api/scoreApi";

// Card #1608 — the Review Queue's FVD write-back-failures section: every org
// ride whose fvdPushStatus is FAILED (score-api GET /ride?fvdPushStatus=FAILED,
// card #1608's extension of listRides' exactly-one-of branching). Org-wide,
// not show-scoped, mirroring useReviewQueue's needsReview lookup — a stuck
// write can happen on any show/day. A ride drops out of this list on its own
// once foxbox reports POSTED on a later retry (#567's reportFvdPushStatus).
export function useFvdPushFailures() {
  const scoreApi = useScoreApi();
  const [state, setState] = useState({ rides: [], loading: true, error: null });

  const refetch = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const rides = unwrap(
        await scoreApi.rides.listRides(
          undefined, // classId
          undefined, // showId
          undefined, // day
          undefined, // ring
          undefined, // needsReview
          undefined, // riderId
          undefined, // horseId
          FVD_PUSH_STATUSES.FAILED,
        ),
      );
      const classIds = [...new Set(rides.map((r) => r.classId).filter(Boolean))];
      const classEntries = await Promise.all(
        classIds.map((id) =>
          scoreApi.classes
            .getClass(id)
            .then(unwrap)
            .then((c) => [id, c])
            .catch(() => [id, null]),
        ),
      );
      const classById = Object.fromEntries(classEntries);
      setState({
        rides: rides.map((r) => ({ ...r, class: classById[r.classId] ?? null })),
        loading: false,
        error: null,
      });
    } catch (err) {
      setState({ rides: [], loading: false, error: err });
    }
  }, [scoreApi]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { ...state, refetch };
}

export default useFvdPushFailures;
